module.exports = __webpack_public_path__ + "static/media/logo_qualdo-bix-light.fbe1c4c4.svg";